export interface AddToCartEligibilityInput {
  isLoading?: boolean;
  /** The catalog detail request failed, so the catalog's answer is unknown. */
  isError?: boolean;
  hasCartPermission: boolean;
  hasProductIdentifiers?: boolean;
  /** Backend flag: null = no catalog price, false = catalog pricing not eligible for online ordering. */
  canAddToCart?: boolean | null;
  containedInCatalog?: boolean | null;
  /** False when the catalog returned no detail for this product. */
  hasCatalogDetail?: boolean;
}

const NOT_IN_CATALOG = "Not available in your product catalog.";

/**
 * Tooltip text for the drawer's disabled Add to Cart button, or null when it is enabled. Mirrors the
 * backend CanAddToCart rule (CommerceCatalogProductMapper).
 */
export function getAddToCartDisabledReason({
  isLoading = false,
  isError = false,
  hasCartPermission,
  hasProductIdentifiers = true,
  canAddToCart,
  containedInCatalog,
  hasCatalogDetail = true,
}: AddToCartEligibilityInput): string | null {
  if (!hasCartPermission) {
    return "You don't have permission to add items to the cart.";
  }
  if (!hasProductIdentifiers) {
    return NOT_IN_CATALOG;
  }
  if (canAddToCart === true) {
    return null;
  }
  if (isLoading) {
    return "Loading product details...";
  }
  if (isError) {
    return "Product details couldn't be loaded. Try again.";
  }
  if (
    !hasCatalogDetail ||
    containedInCatalog === false ||
    canAddToCart == null
  ) {
    return NOT_IN_CATALOG;
  }
  return "Catalog pricing isn't eligible for online ordering.";
}
